import { render, staticRenderFns } from "./AddGroupAccessButton.vue?vue&type=template&id=2d65c4c0&scoped=true"
import script from "./AddGroupAccessButton.vue?vue&type=script&lang=js"
export * from "./AddGroupAccessButton.vue?vue&type=script&lang=js"
import style0 from "./AddGroupAccessButton.vue?vue&type=style&index=0&id=2d65c4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65c4c0",
  null
  
)

export default component.exports